import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "../hooks/use-toast";
import AuthLayout from "../components/AuthLayout";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast({ title: "Welcome back", description: `Signed in as ${u.name}` });
      nav(u.role === "super_admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast({ title: "Login failed", description: err?.response?.data?.detail || "Check your credentials", variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Welcome back" subtitle="Sign in to manage your gift voucher store.">
      {new URLSearchParams(window.location.search).get("suspended") && (
        <p className="mb-4 rounded-xl bg-red-50 text-red-600 text-sm px-4 py-3" data-testid="login-suspended-notice">This account has been suspended. Please contact GiftVouchers.app support.</p>
      )}
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-[#16243b] mb-1.5">Email</label>
          <input type="email" data-testid="login-email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-[#2ec9c9] focus:ring-2 focus:ring-[#2ec9c9]/20 transition" placeholder="you@business.com" />
        </div>
        <div>
          <label className="block text-sm font-medium text-[#16243b] mb-1.5">Password</label>
          <input type="password" data-testid="login-password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-[#2ec9c9] focus:ring-2 focus:ring-[#2ec9c9]/20 transition" placeholder="••••••••" />
        </div>
        <button disabled={loading} data-testid="login-submit" className="gp-btn-teal w-full rounded-xl py-3 font-medium disabled:opacity-60">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="text-sm text-right mt-3">
        <Link to="/forgot-password" className="text-[#1fb0b0] font-medium hover:underline" data-testid="forgot-password-link">Forgot password?</Link>
      </p>
      <p className="text-sm text-[#5a6b80] mt-6 text-center">
        New to GiftVouchers.app? <Link to="/signup" className="text-[#1fb0b0] font-medium hover:underline">Create an account</Link>
      </p>
    </AuthLayout>
  );
}
